import { gql } from '@apollo/client'

export const GET_MESSAGE_HISTORIES = gql`
  query getMessageHistories($uuid: String!) {
    getMessageHistories(uuid: $uuid) {
      actor
      feedback
      message {
        type
        value
      }
      createdAt
      updatedAt
      uuid
    }
  }
`

export const GET_MESSAGE_THREADS = gql`
  query getMessageThreads($agentUuid: String!) {
    getMessageThreads(agentUuid: $agentUuid) {
      createdAt
      updatedAt
      uuid
    }
  }
`
